module.exports = __webpack_public_path__ + "static/img/apple-touch-icon.fd80784f.png";